import Swiper from 'swiper/bundle';
function heroBig() {
    const swiper = new Swiper(".hero-big__slider", {
        loop: true,
        slidesPerView: 1,
        // spaceBetween: 20,
        centeredSlides: true,
        // slidesPerGroup: 1,
        breakpoints: {
            // 640: {
            //     slidesPerView: 1,
            //     spaceBetween: 10,
            // },
            768: {
                slidesPerView: 3,
            },
            // 1024: {
            //     slidesPerView: 3,
            //     spaceBetween: 64,
            // },
        },
    //     autoplay: {
    //   delay: 3500,
    //   disableOnInteraction: false,
    // },
        navigation: {
            nextEl: ".hero-big__slider-next",
            prevEl: ".hero-big__slider-prev",
        },
    });
}


export default heroBig;